import { Component } from '@verndale/core';
import { TabItem } from './index';
// import { loadDeferredModules } from '../../helpers';

class GeneralTab extends Component implements TabItem {
  id: string;
  reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  constructor(
    el: HTMLElement,
    public isActive = false,
    public anchor?: string
  ) {
    super(el);
    this.id = el.id;
    this.el.classList.add('tabs__item--hidden');
  }

  setupDefaults() {
    this.dom = {
      el: this.el
    };
  }

  setActive(isActive: boolean) {
    this.isActive = isActive;

    if (isActive) {
      //loadDeferredModules(this.el);
      this.el.classList.remove('tabs__item--hidden');
    } else {
      this.el.classList.add('tabs__item--hidden');
    }

    return;
  }
}

export default GeneralTab;
